
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const paymentMethods = [
  {
    id: 'mobile',
    label: 'Mobile Money (MoMo)',
    description: ' MTN, Vodafone, AirtelTigo.'
  },
  {
    id: 'card',
    label: 'Card Payment',
    description: 'Visa, MasterCard, Verve'
  },
];

function SelectPaymentMethod() {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentData = location.state || {};
  const [selectedMethod, setSelectedMethod] = React.useState('mobile');

  const handleContinue = () => {
    // Navigate to summary page with all payment data and chosen method
    navigate('/dashboard/summary', { state: { ...paymentData, paymentMethod: selectedMethod } });
  };

  return (
    <div style={{ minHeight: '80vh', background: '#f5f6fa', padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
      <style>{`
        @media (max-width: 768px) {
          .payment-method-title { font-size: 18px !important; }
          .payment-method-subtitle { font-size: 13px !important; }
          .payment-method-label { font-size: 14px !important; }
          .payment-method-desc { font-size: 12px !important; }
          .payment-method-card { padding: 20px 14px !important; }
          .payment-method-option { padding: 12px 10px !important; gap: 10px !important; }
          .payment-method-btn { font-size: 14px !important; padding: 10px 20px !important; }
        }
      `}</style>
      <div style={{ width: '100%', maxWidth: 600 }}>
        <div className="payment-method-card" style={{ background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)', padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: 24 }}>
          <div style={{ marginBottom: 8 }}>
            <h1 className="payment-method-title" style={{ fontSize: '24px', fontWeight: '800', color: '#000', marginBottom: '12px' }}>Select Payment Method</h1>
            <p className="payment-method-subtitle" style={{ fontSize: '16px', color: '#666', margin: 0 }}>Choose how you want to pay for your selected premiums</p>
            <div style={{ width: '100%', height: 1, background: '#eee', margin: '18px 0 0 0' }} />
          </div>
          {paymentMethods.map(method => {
            const isSelected = selectedMethod === method.id;
            return (
              <label
                key={method.id}
                className="payment-method-option"
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 16,
                  cursor: 'pointer',
                  width: '100%',
                  background: '#fff',
                  border: isSelected ? '2px solid #00a651' : '1px solid #eee',
                  borderRadius: 14,
                  boxShadow: isSelected ? '0 2px 8px 0 rgba(0,166,81,0.10)' : 'none',
                  padding: '18px 16px',
                  transition: 'border 0.2s, box-shadow 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={method.id}
                  checked={isSelected}
                  onChange={() => setSelectedMethod(method.id)}
                  style={{ width: 20, height: 20, accentColor: '#00a651', marginTop: 2, cursor: 'pointer' }}
                />
                <div style={{ flex: 1 }}>
                  <div className="payment-method-label" style={{ fontSize: '18px', fontWeight: '600', marginBottom: 6 }}>{method.label}</div>
                  <div className="payment-method-desc" style={{ fontSize: '15px', color: '#666' }}>{method.description}</div>
                </div>
              </label>
            );
          })}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
            <button
              className="btn btn-primary payment-method-btn"
              style={{ padding: '14px 28px', fontSize: '16px', fontWeight: '600', borderRadius: 50, opacity: selectedMethod ? 1 : 0.6, cursor: selectedMethod ? 'pointer' : 'not-allowed' }}
              disabled={!selectedMethod}
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectPaymentMethod;
